import React from 'react';
import { MessageCircle, Target, Sparkles, TrendingUp, Calendar } from 'lucide-react';
export const HowItWorks = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/40736718154', '_blank');
  };
  return <div className="py-20 bg-gray-50" data-id="element-824">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-825">
        <div className="text-center mb-16" data-id="element-826">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-827">
            How It Works
          </h2>
          <p className="text-xl text-gray-600" data-id="element-828">
            From strategy to qualified leads in four simple steps
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-829">
          <Step number="1" icon={<MessageCircle className="w-8 h-8" data-id="element-831" />} title="Tell Us About Your Business" description="Share your product, target market, and goals via WhatsApp or a quick call" data-id="element-830" />
          <Step number="2" icon={<Target className="w-8 h-8" data-id="element-833" />} title="Irina Designs Your Strategy" description="Expert-crafted targeting, messaging, and campaign structure tailored to your needs" data-id="element-832" />
          <Step number="3" icon={<Sparkles className="w-8 h-8" data-id="element-835" />} title="AI Executes at Scale" description="Our AI handles research, personalization, and outreach automation with human oversight" data-id="element-834" />
          <Step number="4" icon={<TrendingUp className="w-8 h-8" data-id="element-837" />} title="Receive Qualified Leads" description="Get weekly reports and qualified leads that meet your criteria" data-id="element-836" />
        </div>
        <div className="mt-16 text-center" data-id="element-838">
          <div className="bg-white rounded-xl p-8 max-w-2xl mx-auto shadow-lg border border-gray-200" data-id="element-839">
            <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-840">
              Ready to Get Started?
            </h3>
            <p className="text-gray-600 mb-6" data-id="element-841">
              Let's discuss your outreach goals and how we can help you generate
              qualified leads
            </p>
            <button onClick={handleWhatsApp} className="px-8 py-4 bg-[#25D366] text-white rounded-lg text-lg font-semibold hover:bg-[#20BA5A] shadow-lg transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2 mx-auto" data-id="element-842">
              <MessageCircle size={24} data-id="element-843" />
              Start the Conversation
            </button>
          </div>
        </div>
      </div>
    </div>;
};
const Step = ({
  number,
  icon,
  title,
  description
}: {
  number: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}) => <div className="relative" data-id="element-844">
    <div className="bg-white rounded-lg p-6 shadow-lg border border-gray-200 h-full" data-id="element-845">
      <div className="absolute -top-4 -left-4 w-12 h-12 bg-[#6366f1] rounded-full flex items-center justify-center text-white font-bold text-xl shadow-lg" data-id="element-846">
        {number}
      </div>
      <div className="w-16 h-16 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center mb-4 text-[#6366f1] mt-4" data-id="element-847">
        {icon}
      </div>
      <h3 className="text-lg font-semibold mb-2 text-gray-900" data-id="element-848">{title}</h3>
      <p className="text-gray-600" data-id="element-849">{description}</p>
    </div>
  </div>;